import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';
import { stripHtml } from '../lib/htmlUtils';

const InfoPagesPage: React.FC = () => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'page', headerName: t('infoPages.page'), flex: 1, minWidth: 220 },
    { field: 'content', headerName: t('infoPages.content'), flex: 2, minWidth: 300, valueFormatter: (value) => stripHtml(value) },
  ];

  const fields = [
    { name: 'page', label: t('infoPages.page'), type: 'text' as const, required: true, width: 'half' as const },
    { name: 'source_url', label: t('infoPages.sourceUrl'), type: 'text' as const, width: 'half' as const },
    { name: 'content', label: t('infoPages.content'), type: 'richtext' as const, width: 'full' as const },
  ];

  return (
    <GenericTablePage
      tableName="info_pages"
      title={t('infoPages.title')}
      columns={columns}
      fields={fields}
    />
  );
};

export default InfoPagesPage;
